import PlanExtended from './PlanExtended'
export default PlanExtended
